import { apparelProductTypeIds, photoBookIds } from 'src/api/productTypes';

// eslint-disable-next-line import/prefer-default-export
export const isPhotobook = (productTypeId: number) => photoBookIds.indexOf(productTypeId) >= 0;
export const isApparelProduct = (productTypeId: number) => apparelProductTypeIds.indexOf(productTypeId) >= 0;

const SIMPLE_PHOTO_MUGS = ['simple-photo', 'simple-photo-left'];

export const checkSimplePhotoMug = (attributeValue: string) => SIMPLE_PHOTO_MUGS.indexOf(attributeValue) !== -1;
